import Avatar from '../../avatar/Avatar';
import useGetUserTier from '../../../services/user/queries/useGetUserTier';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import TierAvatarProgress from '../../avatar/TierAvatarProgress';
import UserControls from './UserControls';
import React from 'react';

interface UserDetailsProps {
  userId: string;
  alias: string;
}

const UserDetails = ({ userId, alias }: UserDetailsProps) => {
  const { isLoading, isSuccess, data } = useGetUserTier({ userId: userId });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!isSuccess) {
    return null;
  }

  const userTier = data.data;

  return (
    <section className="relative mb-5 flex flex-col items-center justify-center gap-4">
      <div className="flex flex-col gap-4">
        <TierAvatarProgress
          progressPercentage={userTier.tierProgressPercentage}
          className="relative -top-16 -mb-16 h-[135px] w-[135px]"
        >
          <Avatar className="h-26 w-26" userId={userId} round={true} />
        </TierAvatarProgress>
        <h2 className="text-center text-lg font-semibold text-ph-gray-white">{alias}</h2>
      </div>
      <UserControls />
    </section>
  );
};

export default UserDetails;
